// 全局变量
import * as Axios from '@/api/index';
import * as validate from '@/config/validate';
import * as $config from '@/config/config';
import {
  Storage,
  $storage
} from "@/utils/from-common";
import * as $var from '@/utils/variables';
import * as $val from '@/config/options.value';

export default {
  install(Vue) {
    Vue.prototype.$axios = Axios;

    // 表单验证模式
    Vue.prototype.$validate = validate;

    // storage
    Vue.prototype.$storage = $storage;

    // session
    Vue.prototype.$session = new Storage({
      source: window.sessionStorage
    });

    // 全局变量
    Vue.prototype.$var = $var;

    // 全局变量
    Vue.prototype.$val = $val;

    // 全局配置
    Vue.prototype.$config = $config;
  }
}